module.exports = __webpack_public_path__ + "linea-arrows-10.5873a30e6baace5f9246.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.svg
// module chunks = styles